import React from "react";
import { Container } from "react-bootstrap";
import ExperienceTimeline from "../components/Experience/ExperienceTimeline";

import Particle from "../components/Particle";
const Experience = () => {
  const experiences = [
    {
      company: "SpiceTech IT Solutions",
      role: "Full Stack Developer",
      duration: "June 2023-Sept 2025",
      location: "Kota, Rajasthan (On-site)",
      points: [
        "Developed and enhanced scalable full-stack features using Next.js, React.js, Tailwind CSS, Node.js, and Express.js, ensuring smooth frontend-backend integration.",
        "Designed and implemented RESTful APIs with Node.js and Express.js, including JWT-based authentication and secure route handling.",
        "Built and maintained 3+ Shopify apps with custom frontend interfaces and backend logic to improve merchant workflows and user experience.",
        "Customized and optimized 50+ Shopify themes and storefronts using Liquid, JavaScript, TypeScript, and Tailwind CSS based on business requirements.",
        "Optimized critical JavaScript execution paths and application workflows, achieving measurable performance improvements in load time and execution efficiency.",
        "Designed MongoDB schemas and implemented CRUD operations to support scalable and maintainable data models.",
        "Built reusable, modular UI components following clean architecture principles to improve code maintainability and scalability.",
        "Tested APIs and application workflows using Postman and collaborated closely with designers and stakeholders to deliver features on time.",
      ],
    },
  ];

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Professional <strong className="yellow">Experience </strong>
        </h1>
        <ExperienceTimeline experiences={experiences} />
      </Container>
    </Container>
  );
};

export default Experience;
